<template>
    <div class="fitting-availability d-flex align-items-center alert p-2 my-2 text-center bg-light" :class="fittingClass">
        <p class="mb-0 w-100 fw-bold" :class="fittingPlaceholderClass" v-html="fittingText"></p>
    </div>
</template>

<script>
    import dayjs from 'dayjs';

    export default {
        props: ['fittingToday', 'fittingTomorrow', 'earliestFittingDate', 'postcode'],
        computed: {
            twoDaysHence: function() {
                return dayjs().add(2, 'day').format('YYYY-MM-DD');
            },
            fittingPlaceholderClass: function() {
                if((typeof(this.fittingToday) == 'undefined') && (typeof(this.fittingTomorrow) == 'undefined') && (typeof(this.earliestFittingDate) == 'undefined')) {
                    return 'placeholder';
                }
            },
            fittingClass: function() {
                if((typeof(this.fittingToday) == 'undefined') && (typeof(this.fittingTomorrow) == 'undefined') && (typeof(this.earliestFittingDate) == 'undefined')) {
                    return 'placeholder-glow';
                }
                else {
                    return this.fittingToday == true ? 'express-bg' : (this.fittingTomorrow == true ? 'clock-bg' : (this.earliestFittingDate <= this.twoDaysHence ? 'default-bg' : 'default-bg'));
                }
            },
            fittingText: function() {
                if((typeof(this.fittingToday) == 'undefined') && (typeof(this.fittingTomorrow) == 'undefined') && (typeof(this.earliestFittingDate) == 'undefined')) {
                    return '';
                }
                else {
                    return this.fittingToday == true ? 'Fitting Today' : (this.fittingTomorrow == true ? 'Fitting Tomorrow' : (this.earliestFittingDate <= this.twoDaysHence ? ('Fit from ' + (this.earliestFittingDate ? dayjs(this.earliestFittingDate).format('DD/MM/YY') : ' 48h')) : ('Fit from ' + (this.earliestFittingDate ? dayjs(this.earliestFittingDate).format('DD/MM/YY') : ' 48h+'))));
                }
            },
            modalText: function() {
                if((typeof(this.fittingToday) == 'undefined') && (typeof(this.fittingTomorrow) == 'undefined') && (typeof(this.earliestFittingDate) == 'undefined')) {
                    return 'Loading fitting availability';
                }
                if(this.fittingToday == true) {
                        return 'Fitting today';
                }
                else if(this.fittingTomorrow == true) {
                    return 'Fitting tomorrow';
                }
                else if(this.earliestFittingDate <= this.twoDaysHence) {
                    return 'Fitting after 2 days';
                }
                else {
                    return 'Fitting within 2 days';
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .fitting-availability {
        border: 1px solid #8BD0D7;
        border-radius: 0;
    }
</style>